

















import { IProfileItem } from "@/store/types";
import { Component, Vue, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import ProfileItem from "./ProfileItem.vue";

@Component({
    components: {ProfileItem}
})
export default class Profile extends Vue {
    public backgroundImagePosition: number = 0;

    @State("scrollPosition")
    public scrollPosition: number;

    public items: IProfileItem[] = [
        {
            icon: "icons8-wardrobe.png",
            title: "Bútorok",
            description: "Iroda és iskola berendezéseink, lakásbútoraink, gyerekbútoraink, " +
                "igazodnak az elvárt igényekhez, az anyagok gazdag választékával, " +
                "szabványosított méretekkel dolgozunk, így a megye egyik legkedvezőbb árfekvésű " +
                "szállítói vagyunk."
        },
        {
            icon: "icons8-window.png",
            title: "Ajtók, ablakok",
            description: "2008-tól számítógép vezérlésű géppel állítjuk elő hossz toldott, " +
                "rétegragasztott borovi fenyőfából, roto vasalattal, fém vízvetővel szerelve. " +
                "Gyártani tudjuk felületkezeléssel 3 rétegű üvegezéssel, dupla gumiszigeteléssel. " +
                "Beépítjük a terméket. 20 év garanciát vállalunk!"
        },
        {
            icon: "icons8-garage-door.png",
            title: "Garázskapuk",
            description: "Az általunk gyártott garázskapuk különlegességét az adja - legyen " +
                "az szekcionált, motoros vagy távirányítású -, hogy rétegragasztott borovi " +
                "fenyőfából készítjük."
        },
        {
            icon: "icons8-stairs.png",
            title: "Falépcsők",
            description: "Helyszíni felmérés alapján tölgyfa, bükkfa, fenyőfa anyagokból " +
                "gyártjuk, de lehetőség van más fafajok beépítésére is."
        },
        {
            icon: "icons8-maintenance.png",
            title: "Átadás",
            description: "A gyors helyszíni beszerelés garantált, igyekszünk a megrendelőnek " +
                "a lehető legkisebb kellemetlenséget okozni. Ennek köszönhető töretlen " +
                "fejlődésünk."
        },
        {
            icon: "icons8-shop.png",
            title: "Üzletünk",
            description: "Bűtor- és épületasztalos vasalatokat, szerelvényeket, kilincseket, " +
                "zárakat, díszítő elemeket, díszüvegeket, rész és króm köszöbborításokat, " +
                "lépcsőkorlát elemeket forgalmazunk nagy- és kiskereskedelmi áron."
        },
        {
            icon: "icons8-money.png",
            title: "Fizetés",
            description: "Megrendelésének kifizetésekor lehetőség van készpénzes számlás, " +
                "átutalásos számlás vagy részletfizetéses rendezésre."
        }
    ];

    @Watch("scrollPosition")
    private handleScrollPositionChange() {
        const topPadding = (window.innerWidth < 762) ? 0 : 500;
        this.backgroundImagePosition =  topPadding - window.innerHeight + this.scrollPosition / 6;
    }
}
